export default __webpack_public_path__ + "static/media/NIAS0090.34I-32792_-17903_0.dd06da59.jpg";